// removed by extract-text-webpack-plugin
module.exports = {"flat":"style__flat___3QWdI boxShadow-deboss--active boxShadow-emboss--hover","ghost":"style__ghost___19nnH bg-none boxShadow-deboss--active boxShadow-emboss--hover boxShadow-smoke c-slate","outlined":"style__outlined___218ST boxShadow-deboss--active boxShadow-emboss--hover boxShadow-smoke c-slate"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-button/Button/style/style.css
// module id = 122
// module chunks = 0 2